import styled from 'styled-components';

export const CardWrapper = styled.div`
  padding: 10px;
  border: 1px solid #8a8a8a;
  border-radius: 20px;
  margin-bottom: 30px;
`;

export const FormFooter = styled.div(
  ({ disabled }: { disabled: boolean }) => `
  display: flex;
  justify-content: ${disabled ? 'space-between' : 'flex-end'};
  margin-top: 20px;
`,
);
